export interface ICIRuleAction {
  name: string;
  type: string;
  value: string;
}

export class CIRuleAction implements ICIRuleAction {
  name: string = '';
  type: string = '';
  value: string = '';

  constructor(data?: ICIRuleAction) {
    if (data) {
      this.name = data.name ?? this.name;
      this.type = data.type ?? this.type;
      this.value = data.value ?? this.value;
    }
  }
}
